import comboComponent from "@/components/child/form/combo.vue";
import { Component } from "@/decorators";
import ConfiguracaoSetorModel from "@/models/configuracaoSetorModel";
import ConfiguracaoSetorService from "@/services/configuracaoSetorService";
import setorService from "@/services/setorService";
import { SessionActions } from "@/store/store";

import EditComponentBase from "../editComponentBase";

@Component({
    components: {
        comboComponent,
    },
})
export default class ConfiguracaoSetorEditComponent extends EditComponentBase<ConfiguracaoSetorModel> {
    // State computed props

    private configuracaoSetorService = new ConfiguracaoSetorService();

    setorOptions = [];

    private async beforeMount() {
        await this.setProps(new ConfiguracaoSetorService(), "configuracao_setor", new ConfiguracaoSetorModel());

        await this.load();
    }

    public async load(): Promise<void> {
        await this.$store.dispatch(SessionActions.LOAD_USUARIO_LOGADO);
        this.setorOptions = await setorService.comboCached(this.usuarioLogado.franquiaId);

        try {
            const data = await this.configuracaoSetorService
                .getByFranquia()
                .withLoading()
                .resolveWithJSON<ConfiguracaoSetorModel>();

            this.model.updateFrom(data);
        } catch {}
    }
}
